// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-history {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    height: 60vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  
  .chat-message {
    max-width: 500px;
    margin: 5px;
    padding: 10px;
    border-radius: 10px;
    white-space: pre-wrap;
  }
  
  .chat-message.bot {
    background-color: grey;
    color: white;
    align-self: flex-start;
  }
  
  .chat-message.user {
    background-color: lightgreen;
    color: black;
    align-self: flex-end;
  }
  
  .chat-input {
    margin-top: 20px;
  }
  
  /* ... (existing styles) */
  
  /* Container for settings */
  .settings {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }
  
  /* Input fields for API Key and User ID */
  .settings input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
  }
  
  /* Login Button */
  .settings button {
    padding: 8px 12px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .settings button:hover {
    background-color: #0056b3;
  }
  
  /* Input field for typing new message */
  .chat-input input[type="text"] {
    flex-grow: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  /* Send Message Button */
  .chat-input button {
    padding: 10px 20px;
    margin-left: 10px;
    background-color: green;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .chat-input button:hover {
    background-color: darkgreen;
  }
  
  /* Chat input container */
  .chat-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ccc;
  }
  
  /* ... (existing styles) */
  `, "",{"version":3,"sources":["webpack://./src/components/chat.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,0BAA0B;;EAE1B,2BAA2B;EAC3B;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;EAC/B;;EAEA,yCAAyC;EACzC;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,uCAAuC;EACvC;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,0BAA0B;EAC5B;;EAEA,0BAA0B","sourcesContent":[".chat-history {\n    margin: 20px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    height: 60vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n  \n  .chat-message {\n    max-width: 500px;\n    margin: 5px;\n    padding: 10px;\n    border-radius: 10px;\n    white-space: pre-wrap;\n  }\n  \n  .chat-message.bot {\n    background-color: grey;\n    color: white;\n    align-self: flex-start;\n  }\n  \n  .chat-message.user {\n    background-color: lightgreen;\n    color: black;\n    align-self: flex-end;\n  }\n  \n  .chat-input {\n    margin-top: 20px;\n  }\n  \n  /* ... (existing styles) */\n  \n  /* Container for settings */\n  .settings {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid #ccc;\n  }\n  \n  /* Input fields for API Key and User ID */\n  .settings input {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-right: 10px;\n  }\n  \n  /* Login Button */\n  .settings button {\n    padding: 8px 12px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .settings button:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Input field for typing new message */\n  .chat-input input[type=\"text\"] {\n    flex-grow: 1;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  /* Send Message Button */\n  .chat-input button {\n    padding: 10px 20px;\n    margin-left: 10px;\n    background-color: green;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .chat-input button:hover {\n    background-color: darkgreen;\n  }\n  \n  /* Chat input container */\n  .chat-input {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    border-top: 1px solid #ccc;\n  }\n  \n  /* ... (existing styles) */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
